// @ts-nocheck

import React, { useRef, useEffect, useState, useCallback } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import ScrollView from '../../../../components/ScrollView';
import GridsContributorsContainer from '../../containers/GridsContributorsContainer';

const MainWrap = styled.div`
  position: relative;
`;

const WrapContributors = styled.div`
  position: relative;
  overflow-x: scroll;
  overflow-y: hidden;

  & > div {
    height: 100%;
  }

  ${({ theme }) =>
    !Target.__MOBILE__
      ? css`
          ${theme.grids.desktopBloc} margin-bottom: 1em;
        `
      : undefined}
`;

const StyledScrollView = styled(ScrollView)`
  cursor: grab;
`;

const Wrap = styled.div`
  position: relative;
  display: inline-block;
  height: 100%;
  user-select: none;
  padding-right: ${({ $isOverflow }) => ($isOverflow ? '40px' : 0)};
`;

const Gradient = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 60px;
  height: 100%;
  background: linear-gradient(to right, rgba(0, 0, 0, 0), ${({ theme }) => theme.grids.colors.black});
  z-index: 4;
  pointer-events: none;
`;

type Props = {
  className?: string;
  gridReference: string;
  isPublicGrid?: boolean;
};

const SwipeContributors = ({ gridReference, isPublicGrid = false, className }: Props) => {
  const ref = useRef(null);
  const [isOverflow, setIsOverflow] = useState(false);

  const detectOverflow = useCallback(() => {
    if (ref.current) {
      const parentElement = ref.current.parentNode;
      const overflow = parentElement.scrollWidth > parentElement.clientWidth;
      setIsOverflow(overflow);
    }
  }, []);

  useEffect(() => {
    detectOverflow();
  }, [detectOverflow]);

  return (
    <MainWrap>
      <WrapContributors className={className}>
        {isOverflow ? (
          <StyledScrollView vertical={false} isOverflowing>
            <Wrap ref={ref} $isOverflow={isOverflow}>
              <GridsContributorsContainer gridReference={gridReference} isPublicGrid={isPublicGrid} />
            </Wrap>
          </StyledScrollView>
        ) : (
          <Wrap ref={ref}>
            <GridsContributorsContainer gridReference={gridReference} isPublicGrid={isPublicGrid} />
          </Wrap>
        )}
      </WrapContributors>
      {isOverflow && <Gradient />}
    </MainWrap>
  );
};

export default SwipeContributors;
